import { Component, HostListener, OnInit } from '@angular/core';
// @ts-ignore
import { OAuthService } from "angular-oauth2-oidc";
import { filter } from "rxjs/operators";
import { DataLayerService } from "./core/services/data-layer.service";
import { NavigationEnd } from "@angular/router";
import { CustomRouter as Router } from "./core/utils/custom-router";
import { StyleService } from './style-guide/services/style.service';
import { AuthService } from './core/services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  route: string = '';
  title = 'Negocie com a Omni';
  pdfDocument: any;
  pdfHistory: any;
  pdfLinkService: any;
  eventBus: any;
  currentBinaryArray: any;
  globalDocument: any = document;

  DEFAULT_SCALE_DELTA = 1.1;
  MAX_SCALE = 2.0;
  MIN_SCALE = 0.25;

  constructor(
    private oauthService: OAuthService,
    private _router:Router,
    private _dataLayerService: DataLayerService,
    private styleService: StyleService,
    private authService: AuthService,
  ) {
    this.subscribeOauthEvents();
    this.subscribeRouterEvents();
  }

  subscribeOauthEvents() {
    this.oauthService.events
    .pipe(filter((e: any) => e.type === 'invalid_nonce_in_state'))
    .subscribe(() => {
      console.log('invalid_nonce_in_state');
      this.oauthService.initImplicitFlow();
    });
  }

  subscribeRouterEvents() {
    this._router.events().subscribe(event=> { // subscribe to router events
      if (event instanceof NavigationEnd) //if our event is of our interest
      {
        //GTM:ID0-1
        this._dataLayerService.logEvent({
          event: 'page_view',
          page_path: event.url,
          page_title: document.title,
          page_location: window.location?.href,
        });
      }
    });
  }

  ngOnInit() {
    this.styleService.setCSSVariables();
  }

  @HostListener('window:pageshow', ['$event'])
  onPageShow() {
    setTimeout(() => {
      if (!this.authService.isLoggedOn()) {
        this._router.navigate(['/']);
      }
    }, 1500);
  }
}